export default __webpack_public_path__ + "static/media/Boton Estimulos.f6adeb3e.jpg";